// extracted by mini-css-extract-plugin
export default {"little":"Recaptcha_little__mTDO6","subTittle":"Recaptcha_subTittle__C4qve"};